import Button from 'apollo-react/components/Button';
import React from 'react';

import { pages } from '../../../../../Shared/constants';

const NavigationButtonsComponent = ({
  handleSetPage,
  classes,
  intl,
  steps,
  handleSubmit,
  onlyCancel,
  closeActivity,
  disabled,
}) => {
  if (onlyCancel) {
    return (
      <div className={classes.submit}>
        <Button onClick={closeActivity} variant="secondary">
          {intl.formatMessage({ id: 'journeyBuilder.cancel' })}
        </Button>
      </div>
    );
  }
  return (
    <div className={classes.submit}>
      <Button onClick={closeActivity} variant="secondary">
        {intl.formatMessage({ id: 'journeyBuilder.cancel' })}
      </Button>
      {steps.key === pages.step1.key ? (
        <Button
          name="next"
          disabled={disabled}
          onClick={() => {
            handleSetPage(pages.step2);
          }}
          variant="primary"
        >
          {intl.formatMessage({ id: 'journeyBuilder.next' })}
        </Button>
      ) : (
        <div>
          <Button
            onClick={() => {
              handleSetPage(pages.step1);
            }}
            variant="secondary"
            className={classes.rightBtns}
          >
            {intl.formatMessage({ id: 'journeyBuilder.back' })}
          </Button>
          <Button onClick={handleSubmit} className={classes.rightBtns} variant="primary">
            {intl.formatMessage({ id: 'journeyBuilder.done' })}
          </Button>
        </div>
      )}
    </div>
  );
};

NavigationButtonsComponent.displayName = 'NavigationButtonsComponent';

export default NavigationButtonsComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/Navigation/NavigationButtons/NavigationButtonsComponent.js